var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.503 13.525-.303 2.1c-.148 1.032-.223 1.547-.052 1.9.15.31.416.546.74.658.371.127.875-.008 1.88-.277l13.016-3.488c1.007-.27 1.51-.404 1.767-.7.226-.259.338-.597.313-.94-.03-.39-.351-.8-.995-1.619l-1.313-1.668c-.141-.18-.212-.27-.279-.362a5.147 5.147 0 0 1-.726-1.45c-.034-.108-.063-.219-.123-.44-1.22-4.554-5.005-7.089-9.145-5.98-4.14 1.11-6.15 5.198-4.93 9.751.06.222.09.332.114.443.117.531.15 1.078.096 1.619-.011.113-.027.226-.06.453Zm4.471 6.452 6.624-1.775s.06 3.534-2.838 4.31c-2.898.777-3.786-2.535-3.786-2.535Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell24);
export default __webpack_public_path__ + "static/media/bell_24.45c2119c.svg";
export { ForwardRef as ReactComponent };